export const SliceName = {
  Package: 'package',
  Claim: 'claim',
  Review: 'review',
  Policy: 'policy',
  Feedback: 'feedback',
  LayoutSetting: 'layoutSetting',
};
